import React from 'react';
import { formatCurrency } from 'utils/currencyHelper';

export const PartialBalanceCell = ({ cell }) => {
  const { partialBalance } = cell.original;
  
  if (!partialBalance) return <span>-</span>;
  
  // Detectar si el saldo es negativo
  const isNegative = partialBalance.amount < 0;
  const formattedBalance = formatCurrency(Math.abs(partialBalance.amount), partialBalance.currency);
  
  return (
    <span className={`partial-balance-cell`}>
      {isNegative ? '-' : ''}{formattedBalance}
    </span>
  );
};